import { Link } from 'react-router-dom';
import { siteInfo } from '@/mocks/site';

const GROUPS = [
  {
    title: '追踪内容',
    links: [
      { to: '/dramas', label: '剧集库' },
      { to: '/calendar', label: '追剧日历' },
      { to: '/', label: '最新分集介绍' },
      { to: '/', label: '下一集预告' },
    ],
  },
  {
    title: '主题分类',
    links: [
      { to: '/dramas', label: '都市逆袭' },
      { to: '/dramas', label: '古装剧场' },
      { to: '/dramas', label: '甜宠恋爱' },
      { to: '/dramas', label: '悬疑推理' },
    ],
  },
  {
    title: '关于本站',
    links: [
      { to: '/about', label: '品牌介绍' },
      { to: '/about', label: '内容原则' },
      { to: '/about', label: '用户口碑' },
      { to: '/about', label: '联系我们' },
    ],
  },
];

export default function SiteFooter() {
  return (
    <footer className="mt-20 border-t border-background-200 bg-secondary-950 text-background-100">
      <div className="mx-auto w-full max-w-content px-4 py-12 md:px-6 md:py-16">
        <div className="grid grid-cols-1 gap-10 lg:grid-cols-12">
          <div className="lg:col-span-4">
            <div className="flex items-center gap-3">
              <span className="flex h-10 w-10 items-center justify-center rounded-md bg-accent-500 text-secondary-950">
                <i className="ri-movie-2-line text-xl" aria-hidden="true" />
              </span>
              <span className="font-heading text-xl font-bold text-background-50">爆料短剧</span>
            </div>
            <p className="mt-4 max-w-sm text-sm leading-7 text-background-300">
              按连续剧集更新顺序整理追剧日历，剧情分集介绍清楚标注，下一集预告提前放，全季剧情梗概一拉到底。收藏一份，追剧不漏更。
            </p>
            <p className="mt-5 flex items-center gap-2 text-sm text-background-300">
              <i className="ri-mail-line text-accent-400" aria-hidden="true" />
              {siteInfo.email}
            </p>
          </div>

          {GROUPS.map((group) => (
            <div key={group.title} className="lg:col-span-2">
              <h4 className="font-heading text-sm font-semibold tracking-wide text-background-50">
                <Link to={group.links[0].to} className="cursor-pointer">{group.title}</Link>
              </h4>
              <ul className="mt-4 space-y-3">
                {group.links.map((link) => (
                  <li key={link.label}>
                    <Link
                      to={link.to}
                      className="cursor-pointer text-sm text-background-300 transition-colors hover:text-accent-400"
                    >
                      {link.label}
                    </Link>
                  </li>
                ))}
              </ul>
            </div>
          ))}

          <div className="lg:col-span-2">
            <h4 className="font-heading text-sm font-semibold tracking-wide text-background-50">
              <Link to="/calendar" className="cursor-pointer">今日更新</Link>
            </h4>
            <p className="mt-4 text-sm leading-6 text-background-300">
              周四 20:00
              <br />
              《心动信号：暗恋成真》
              <br />
              第 33-34 集
            </p>
          </div>
        </div>

        <div className="mt-10 flex flex-col gap-3 border-t border-secondary-800 pt-6 text-xs text-background-400 sm:flex-row sm:items-center sm:justify-between">
          <p>© {new Date().getFullYear()} 爆料短剧 · 本站内容为剧情整理与更新追踪，仅供追剧参考</p>
          <p>最后更新：2026-09-10</p>
        </div>
      </div>
    </footer>
  );
}